
export const BASIC_TYPE = {
    default: 'defaultTypes',
    classification: 'classificationTypes',
    year: 'yearTypes',
    status: 'statusTypes',
    range: 'rangeTypes',
    authority: 'authorityTypes',
    yearRange: 'yearRangeTypes', // compatible with paper
    group: 'groupTypes', // compatible with snap-business
    checkRange: 'checkRangeTypes',
    radio: 'radioTypes',
    color: 'colorTypes',
    layer: 'layerTypes',
    benefit: 'benefitTypes',
    ups: 'upStatusTypes',
    length: 'lengthTypes',
    customField: 'customFieldTypes',
    pum: 'pumTypes',
};

export const FIELD_TYPES = {
    // default
    VPM_ED: BASIC_TYPE.default,
    ANCS: BASIC_TYPE.default,
    ANC: BASIC_TYPE.default,
    ANS: BASIC_TYPE.default,
    AN: BASIC_TYPE.default,

    GNAME: BASIC_TYPE.default,
    ANCS_TYPE: BASIC_TYPE.default,
    PATENT_TYPE: BASIC_TYPE.default,
    IN_FACET: BASIC_TYPE.default,
    F_IN: BASIC_TYPE.default,
    ATC_CN_FACET: BASIC_TYPE.default,
    ATCS: BASIC_TYPE.default,
    ATC_VALUE: BASIC_TYPE.default,
    ATC_FACET: BASIC_TYPE.default,
    F_ANC: BASIC_TYPE.default,
    ANC_PROVINCE: BASIC_TYPE.default,
    SEP_SOURCE: BASIC_TYPE.default,
    WS_READ_STATUS: BASIC_TYPE.default,
    ANS_TYPE: BASIC_TYPE.default,
    OUTCOME_TYPE_CN: BASIC_TYPE.default,

    AN_COUNTRY: BASIC_TYPE.default,
    ANC_COUNTRY: BASIC_TYPE.default,

    ANC_CITY: BASIC_TYPE.default,
    ANC_DISTRICT_FACET: BASIC_TYPE.default,

    PROBLEM_PHRASE_ID: BASIC_TYPE.default,

    BENEFIT_PHRASE_ID: BASIC_TYPE.default,

    // classification
    IPC_FACET: BASIC_TYPE.classification,
    IPC_MAIN_GROUP: BASIC_TYPE.classification,
    IPC_SUB_CLASS: BASIC_TYPE.classification,
    IPC_CLASS: BASIC_TYPE.classification,
    IPC_SECTION: BASIC_TYPE.classification,

    CPC_FACET: BASIC_TYPE.classification,
    CPC_MAIN_GROUP: BASIC_TYPE.classification,
    CPC_SUB_CLASS: BASIC_TYPE.classification,
    CPC_CLASS: BASIC_TYPE.classification,
    CPC_SECTION: BASIC_TYPE.classification,

    CPC_ALL_FACET: BASIC_TYPE.classification,
    CPC_MAIN_GROUP_ALL: BASIC_TYPE.classification,
    CPC_SUB_CLASS_ALL: BASIC_TYPE.classification,
    CPC_CLASS_ALL: BASIC_TYPE.classification,
    CPC_SECTION_ALL: BASIC_TYPE.classification,

    LOC_FACET: BASIC_TYPE.classification,
    LOC_CLASS: BASIC_TYPE.classification,

    UPC_CLASS: BASIC_TYPE.classification,
    UPC_FACET: BASIC_TYPE.classification,

    GBC_FACET: BASIC_TYPE.classification,
    GBC_GROUP: BASIC_TYPE.classification,
    GBC_DIVISION: BASIC_TYPE.classification,
    GBC_SECTION: BASIC_TYPE.classification,

    FI_FACET: BASIC_TYPE.classification,
    FI_SUB_GROUP: BASIC_TYPE.classification,
    FI_MAIN_GROUP: BASIC_TYPE.classification,
    FI_SUB_CLASS: BASIC_TYPE.classification,
    FI_CLASS: BASIC_TYPE.classification,
    FI_SECTION: BASIC_TYPE.classification,

    FTERM_FACET: BASIC_TYPE.classification,
    FTERM_THEME_CODE: BASIC_TYPE.classification,

    MIPC: BASIC_TYPE.classification,
    MIPC_FACET: BASIC_TYPE.classification,
    MIPC_MAIN_GROUP: BASIC_TYPE.classification,
    MIPC_SUB_CLASS: BASIC_TYPE.classification,
    MIPC_CLASS: BASIC_TYPE.classification,
    MIPC_SECTION: BASIC_TYPE.classification,

    MCPC_FACET: BASIC_TYPE.classification,
    MCPC_MAIN_GROUP: BASIC_TYPE.classification,
    MCPC_SUB_CLASS: BASIC_TYPE.classification,
    MCPC_CLASS: BASIC_TYPE.classification,
    MCPC_SECTION: BASIC_TYPE.classification,

    ADC: BASIC_TYPE.classification,
    ADC_A: BASIC_TYPE.classification,
    ADC_B: BASIC_TYPE.classification,
    ADC_C: BASIC_TYPE.classification,
    ADC_D: BASIC_TYPE.classification,

    TTC_CLUSTER: BASIC_TYPE.classification,
    TTC_CLUSTER_LA: BASIC_TYPE.classification,
    TTC_CLUSTER_LB: BASIC_TYPE.classification,
    TTC_CLUSTER_LC: BASIC_TYPE.classification,

    SEIC: BASIC_TYPE.classification,
    SEIC_A: BASIC_TYPE.classification,
    SEIC_B: BASIC_TYPE.classification,

    SEIC_ALL: BASIC_TYPE.classification,
    SEIC_ALL_A: BASIC_TYPE.classification,
    SEIC_ALL_B: BASIC_TYPE.classification,

    // year
    APD_Y: BASIC_TYPE.year,
    F_PBD_Y: BASIC_TYPE.year,
    PBD_Y: BASIC_TYPE.year,
    ISD_Y: BASIC_TYPE.year,
    EXPD_Y: BASIC_TYPE.year,
    PRIORITY_YEAR: BASIC_TYPE.year,
    E_PRIORITY_YEAR: BASIC_TYPE.year,
    EFAM_EPBY: BASIC_TYPE.year,
    EFAM_EPRY: BASIC_TYPE.year,

    // status
    SIMPLE_LEGAL_STATUS: BASIC_TYPE.status,
    LEGAL_STATUS: BASIC_TYPE.status,
    LEGAL_EVENT: BASIC_TYPE.status,
    EPDS_SLS: BASIC_TYPE.status,
    EFAM_STATUS: BASIC_TYPE.status,
    ENTRY_COUNTRY_LS: BASIC_TYPE.status,
    ENTRY_COUNTRY_SLS: BASIC_TYPE.status,

    // range
    ANC_COUNT: BASIC_TYPE.range,
    B_CITES_COUNT: BASIC_TYPE.range,
    F_CITES_COUNT: BASIC_TYPE.range,
    EFAM_COUNT: BASIC_TYPE.range,
    PV: BASIC_TYPE.range,
    INPADOC_FAMILY_COUNT: BASIC_TYPE.range,
    EXDT_TS: BASIC_TYPE.range,
    IFAM_COUNT: BASIC_TYPE.range,
    CLAIM_COUNT: BASIC_TYPE.range,
    FCLMS_WORDCOUNT: BASIC_TYPE.range,
    FAM_COUNTRY_COUNT: BASIC_TYPE.range,
    EFAM_COUNTRY_COUNT: BASIC_TYPE.range,

    // authority
    COUNTRY: BASIC_TYPE.authority,
    EFAM_COUNTRY: BASIC_TYPE.authority,
    FAM_COUNTRY: BASIC_TYPE.authority,
    EPDS: BASIC_TYPE.authority,
    ENTRY_COUNTRY: BASIC_TYPE.authority,
    // compatible with snap-business
    CLASSIFICATION_TYPE: BASIC_TYPE.group,
    WS_COMMENT_BY: BASIC_TYPE.default,
    WS_CREATED_AT: BASIC_TYPE.yearRange,

    WS_AI_FIELD: BASIC_TYPE.customField,

    SEQ_ED: BASIC_TYPE.radio,

    // ups
    UP_STATUS: BASIC_TYPE.ups,

    // Paper
    datetime_ts: BASIC_TYPE.yearRange,
    journal_name_keyword: BASIC_TYPE.default,
    master_affiliation_id: BASIC_TYPE.default,
    author_id: BASIC_TYPE.default,
    citation_count: BASIC_TYPE.range,
    normalized_topic_id: BASIC_TYPE.default,
    doc_type: BASIC_TYPE.default,
    text_availability: BASIC_TYPE.default,
    country_name_standard: BASIC_TYPE.default,

    // market
    published_ts: BASIC_TYPE.yearRange,
    normalized_address_id: BASIC_TYPE.default,
    master_normalized_organization_id: BASIC_TYPE.default,
    normalized_category_id: BASIC_TYPE.default,
    publisher_keyword: BASIC_TYPE.default,
    sector_name_keyword: BASIC_TYPE.default,

    // vc investment
    announced_ts: BASIC_TYPE.yearRange,
    money_amount: BASIC_TYPE.checkRange,
    funding_type: BASIC_TYPE.default,
    series: BASIC_TYPE.default,
    master_invested_organization_entity_size: BASIC_TYPE.checkRange,
    master_invested_organization_country_id: BASIC_TYPE.default,
    master_investor_organization_id: BASIC_TYPE.default,
    investor_person_keyword: BASIC_TYPE.default,
    master_invested_organization_id: BASIC_TYPE.default,

    // merger
    transaction_value: BASIC_TYPE.checkRange,
    master_target_id: BASIC_TYPE.default,
    master_purchaser_id: BASIC_TYPE.default,
    percent_total: BASIC_TYPE.checkRange,
    status: BASIC_TYPE.default,
    primary_deal_type: BASIC_TYPE.default,
    deal_types: BASIC_TYPE.default,
    payment_type: BASIC_TYPE.default,
    cross_industry: BASIC_TYPE.radio,
    cross_country: BASIC_TYPE.radio,
    purpose: BASIC_TYPE.default,
    target_country_id: BASIC_TYPE.default,
    purchaser_country_id: BASIC_TYPE.default,

    // patentColour
    patent_colour: BASIC_TYPE.color,

    // eureka
    BENEFIT_TP_ID: BASIC_TYPE.benefit,
    TECH_DOMAIN: BASIC_TYPE.default,
    TECH_DOMAIN_ONE_ID: BASIC_TYPE.default,
    TECH_DOMAIN_SEC_ID: BASIC_TYPE.default,

    // bio
    SEQ_TYPE: BASIC_TYPE.default,
    SEQ_LENGTH: BASIC_TYPE.length,
    IS_BIO: BASIC_TYPE.default,

    // SUBSTANCE_IDS
    SUBSTANCE_IDS: BASIC_TYPE.default,
    PUM_PROP_ID: BASIC_TYPE.pum,

    // layer
    NEV: BASIC_TYPE.layer,
};
